<ul class="layout-menu">
    <ng-container *ngFor="let item of model; let i = index;">
        <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
    <li (click)="childlogoutclick()">
        <ul>
            <li>
                <a class="logout">
                    <i class="pi icon-logout pi-fw layout-menuitem-icon"></i>
                    <span></span>
                    {{ 'COMMON.LOGOUT' | translate }}
                </a>
            </li>
        </ul>
    </li>
</ul>
<!-- showlogoutconfirmationdialog -->